<div fxLayout="row" class="background">
  <div fxFlex="80" fxFlexOffset="10%">

    <section id="header">
      <h1 class="h1Header">SLIDER DE INICIO</h1>
    </section>

    <mat-card class="mat-elevation-z0">
      <div>
        <button mat-raised-button class="add-btn" (click)="addSlider()">Agregar Nuevo</button>
      </div>
      <table mat-table [dataSource]="allSliders" class="mat-elevation-z0">

        <!-- Image Column -->
        <ng-container matColumnDef="imagen">
          <th mat-header-cell *matHeaderCellDef class="table-header"> IMAGEN </th>
          <td mat-cell *matCellDef="let element">
            <img class="logo" [src]="element.dsImg" alt=""/>
          </td>
        </ng-container>

        <!-- Order Column -->
        <ng-container matColumnDef="orden">
          <th mat-header-cell *matHeaderCellDef class="table-header"> ORDEN NO.</th>
          <td mat-cell *matCellDef="let element"> {{element.nmSortNo}} </td>
        </ng-container>

        <!-- Title Column -->
        <ng-container matColumnDef="titulo">
          <th mat-header-cell *matHeaderCellDef class="table-header">TITULO </th>
          <td mat-cell *matCellDef="let element">{{element.dsTitle}}</td>
        </ng-container>

        <!-- Option Column -->
        <ng-container matColumnDef="opcion">
          <th mat-header-cell *matHeaderCellDef class="table-header"> OPCIÓN </th>
          <td mat-cell *matCellDef="let element">
            <button mat-mini-fab class="edit-btn" 
            matTooltip="Editar slider" (click)="editSlider(element.cdSlider)">
              <mat-icon>create</mat-icon>
            </button>
            <button mat-mini-fab class="delete-btn"
            matTooltip="Eliminar slider" (click)="deleteSlider(element.cdSlider)">
              <mat-icon>delete</mat-icon>
            </button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

      </table>
    </mat-card>
  </div>
</div>
